import React from 'react';
import flattenChildren from 'react-keyed-flatten-children';

export const ButtonBar: React.FC = ({ children }) => {
    const childArray = flattenChildren(children);
    return (
        <div style={{display: 'flex', justifyContent: 'center', gap: 10}}>
            {childArray.map((child, i) => (
                <div key={`button-${i}`} style={{flexBasis: `${100/childArray.length}%`}}>{child}</div>
            ))}
        </div>
    );
};
